import dynamic from 'next/dynamic';
import { AssociateHeaderProps } from './AssociateHeader.types';

export const AssociateHeader = dynamic<{ model: AssociateHeaderProps }>(() =>
  import('./AssociateHeader').then(mod => mod.AssociateHeader)
);
